export const application = {
  apiUrl: process.env.REACT_APP_API_URL || 'https://admin-api.exnovin.io',
  wsUrl: process.env.REACT_APP_WS_URL || 'https://ws.exnovinmarket.com',
  platformName: process.env.REACT_APP_PLATFORM_NAME || 'exnovin',
  supportV2: process.env.REACT_APP_SUPPORT_V2 === "true",
};

export const baseTokenSymbol = 'TMN';
export const fetchIntervalTime = 60000;
export const debounceWaitTime = 500;

export const reactTableText = {
  previousText: 'صفحه قبل',
  nextText: 'صفحه بعد',
  loadingText: 'بارگذاری...',
  noDataText: 'هیج ردیفی پیدا نشد',
  pageText: 'صفحه',
  ofText: 'از',
  rowsText: 'ردیف',
};
